















import { Vue, Component } from 'vue-property-decorator'
import ChoosePlan from '../components/ChoosePlan.vue'

@Component({
    components: {
        ChoosePlan,
    },
})
export default class Package extends Vue {
    product: { id: string; description: string } | null = null

    get package() {
        return this.$route.params.package
    }

    call(product: any): void {
        this.product = product
    }
}
